module.exports = __webpack_public_path__ + "static/media/Ableton.3e6ae130.png";